import { render, staticRenderFns } from "./BaseGeneric.vue?vue&type=template&id=1a73c003&scoped=true&"
import script from "./BaseGeneric.vue?vue&type=script&lang=js&"
export * from "./BaseGeneric.vue?vue&type=script&lang=js&"
import style0 from "./BaseGeneric.vue?vue&type=style&index=0&id=1a73c003&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a73c003",
  null
  
)

export default component.exports